import { APP_SCHEME_PROTOCOLS } from './getAppScheme'

const APP_SCHEME_PROTOCOL_SET = new Set(
  APP_SCHEME_PROTOCOLS.map(protocol => `${protocol}:`)
)

const getProtocol = (url: string): string | null => {
  try {
    return new URL(url).protocol
  } catch {
    return null
  }
}

/**
 * 환경별 앱스킴(macarongapp·macarongappdev·macarongappstage) URL인지 판정
 */
export const isAppSchemeUrl = (url: string): boolean => {
  const protocol = getProtocol(url)

  return protocol !== null && APP_SCHEME_PROTOCOL_SET.has(protocol)
}

/**
 * 서버·어드민에서 받은 URL로 이동하기 전 방어 — http/https 외 스킴(javascript: 등) 차단.
 *
 * @param allowAppScheme 인앱 웹뷰에서만 true. 앱이 아닌 브라우저에서 앱스킴으로 이동하면
 *                       아무 일도 일어나지 않거나 에러 페이지가 뜬다.
 */
export const isSafeUrl = (url: string, allowAppScheme = false): boolean => {
  const protocol = getProtocol(url)
  if (protocol === null) return false
  if (APP_SCHEME_PROTOCOL_SET.has(protocol)) return allowAppScheme

  return protocol === 'http:' || protocol === 'https:'
}
